 

import React from 'react'

const ValuePropositionPage = () => {
  return (
<div className="about-section">
      <span className="about-label">Value Proposition</span>
      <div className="about-gold-bar" />
      <p className="about-body">
        We help organizations move from fragmented transformation initiatives to
        integrated, AI-powered operating models—turning pilots into production
        and strategy into sustained outcomes.
      </p>
    </div>   )
}

export default ValuePropositionPage
